<template>
    <div class="main">
        <div class="orders-overview mt-1">
            <div class="row">
                <div class="mx-auto col-md-6 mt-5">
                    <b-button ariant="primary" to="/">
                        Change Store
                    </b-button>
                    <hr>
                    <b-form-select 
                        v-model="category" 
                        :options="categories" 
                        @change="updateCategory"
                    >
                    </b-form-select>

                    <div v-if="products">
                        <b-card no-body class="overflow-hidden" style="max-width: 540px;" 
                            v-for="(product, index) in products" :key="index"
                        >
                            <b-row no-gutters>
                            <b-col md="6">
                                <!-- <b-card-img src="https://picsum.photos/400/400/?image=20" class="rounded-0"></b-card-img> -->
                            </b-col>
                            <b-col md="6">
                                <p class="alert-info" v-if="!canAddToCart(product)">This item is already in your cart in the available quantites</p>
                                <b-card-body :title="product.name"><b-badge>{{product.pivot.inventory}} items available</b-badge>
                                <b-card-text>
                                    {{product.description}}

                                    <b-button @click="addToCart(product)" :disabled="!canAddToCart(product)">Add to Cart</b-button>
                                </b-card-text>
                                </b-card-body>
                            </b-col>
                            </b-row>
                        </b-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Shop',
    data() {
        return {
            selected: null,
            category: null
        }
    },
    computed : {
        storeId() {
            return this.$store.getters.STORE_ID
        },
        categories() {
            var categories = this.$store.getters.CATEGORIES.map((category) => {
                return {"text": category.name, "value": category.id}
            })
            categories.unshift({"text": 'Select a category', "value": null, "disabled": true})
            return categories
        },
        products() {
            return this.$store.getters.PRODUCTS
        },
        cartProducts() {
            return this.$store.getters.CART_PRODUCTS
        }
    },
    mounted () {
      if(this.storeId) this.$store.dispatch('GET_STORE_DATA')
    },
    methods: {
        canAddToCart: function (product) {
            if(product.pivot.inventory > 0) {
                return !this.productQuantityInCart(product)
            }

            return false
        },
        productQuantityInCart: function (product) {

            product = this.cartProducts.find((cartProduct) => {
                return cartProduct.id === product.id && cartProduct.pivot.quantity === product.pivot.inventory
            })

            if(product) return true

            return false
        },
        updateCategory: function (e) {
            this.$store.commit('SET_CATEGORY_ID', e)
            this.$store.dispatch('GET_CATEGORY_PRODUCTS')
        },
        setStore: function (e) {
            this.$store.dispatch('SETUP_STORE', e)
        },
        addToCart: function (product) {
            this.$store.dispatch('ADD_PRODUCT_TO_CART', product)
        }
    }
}
</script>

<style scoped>
    .vertical-scroll.card-body{
        overflow-y: scroll;
        height: 75vh;
    }
</style>